<template>
  <ProductListPagination v-if="totalPages > 1" class="product-list-pagination">
    <nav class="product-list-pagination__nav">
      <ul class="product-list-pagination__list">
        <li
          class="product-list-pagination__list-item product-list-pagination__list-item--prev"
        >
          <a
            href="javascript:"
            class="product-list-pagination__link product-list-pagination__link--prev"
            :class="{
              'product-list-pagination__link--disabled': currentPage <= 1
            }"
            @click.prevent="handlePageChange(currentPage - 1)"
          >
            <span class="visually-hidden">{{ prevLabel }}</span>
          </a>
        </li>
        <li
          v-if="currentPage - 2 >= 1"
          class="product-list-pagination__list-item"
        >
          <a
            href="javascript:"
            class="product-list-pagination__link"
            @click.prevent="handlePageChange(currentPage - 2)"
          >
            {{ currentPage - 2 }}
          </a>
        </li>
        <li
          v-if="currentPage - 1 >= 1"
          class="product-list-pagination__list-item"
        >
          <a
            href="javascript:"
            class="product-list-pagination__link"
            @click.prevent="handlePageChange(currentPage - 1)"
          >
            {{ currentPage - 1 }}
          </a>
        </li>
        <li
          class="product-list-pagination__list-item product-list-pagination__list-item--active"
        >
          <a
            href="javascript:"
            class="product-list-pagination__link product-list-pagination__link--active"
          >
            {{ currentPage }}
          </a>
        </li>
        <li class="product-list-pagination__list-item">
          <a
            v-if="currentPage + 1 <= totalPages"
            href="javascript:"
            class="product-list-pagination__link"
            @click.prevent="handlePageChange(currentPage + 1)"
          >
            {{ currentPage + 1 }}
          </a>
        </li>
        <li class="product-list-pagination__list-item">
          <a
            v-if="totalPages && currentPage + 2 <= totalPages"
            href="javascript:"
            class="product-list-pagination__link"
            @click.prevent="handlePageChange(currentPage + 2)"
          >
            {{ currentPage + 2 }}
          </a>
        </li>
        <li
          class="product-list-pagination__list-item product-list-pagination__list-item--next"
        >
          <a
            href="javascript:"
            class="product-list-pagination__link product-list-pagination__link--next"
            :class="{
              'product-list-pagination__link--disabled':
                currentPage >= totalPages
            }"
            @click.prevent="handlePageChange(currentPage + 1)"
          >
            <span class="visually-hidden">{{ nextLabel }}</span>
          </a>
        </li>
      </ul>
    </nav>
  </ProductListPagination>
</template>

<script setup lang="ts">
import { ProductListPagination } from '@hypercodestudio/basler-components';

interface Props {
  currentPage: number;
  totalPages: number;
  prevLabel?: string;
  nextLabel?: string;
}

const props = withDefaults(defineProps<Props>(), {
  prevLabel: 'Previous page',
  nextLabel: 'Next page'
});
const emit = defineEmits(['page-change']);

const handlePageChange = (page: number) => {
  // Don't allow navigating to pages less than 1 or greater than totalPages
  if (page < 1 || page > props.totalPages) {
    return;
  }

  emit('page-change', page);
};
</script>

<style scoped>
.product-list-pagination__link--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
